import { createApi } from '@reduxjs/toolkit/query/react';
import { endPoints, urlKeys } from 'src/api/APIEndpoints';
import { archLevel } from 'src/data/config';
import { formatString } from 'src/util/STR';
import { baseQuery } from './baseQuery';

export const sqFollowupLetterApi = createApi({
  baseQuery,
  reducerPath: 'sqFollowupLatterApi',
  endpoints: builder => ({
    getSqFollowupLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.sqFollowupLatter.getAll
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    getSqPublishFollowupLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country }) => ({
        url: `${formatString(
          endPoints.sqFollowupLatter.getPublish
        )}?site_id=${site_id}&study_id=${study_id}&country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    selectSqFollowupLetter: builder.query<any, any>({
      query: ({ site_id, study_id, country, visit_follow_up_id }) => ({
        url: `${formatString(
          endPoints.sqFollowupLatter.select,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
          // ${study_id !== null ? `&study_id=${study_id}` : ''}
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }${
          visit_follow_up_id !== null || visit_follow_up_id !== undefined
            ? `&visit_follow_up_id=${visit_follow_up_id}`
            : ''
        }`,
        method: 'GET'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    updateSqFollowupLetter: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data }) => ({
        url: `${formatString(
          endPoints.sqFollowupLatter.update,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    signSqFollowupLetter: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, data, sq_visit_id }) => ({
        url: `${formatString(
          endPoints.sqFollowupLatter.sign,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }&sq_visit_id=${sq_visit_id}`,
        method: 'PUT',
        body: data
      }),
      extraOptions: { maxRetries: 3 }
    }),
    publishSqFollowupLetter: builder.mutation<any, any>({
      query: ({
        site_id,
        study_id,
        country,
        sq_visit_id,
        publish_doc_version,
        time_zone_id,
        is_published_etmf,
        update
      }) => ({
        url: `${formatString(
          endPoints.sqFollowupLatter.publish,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id }
        )}?country=${country}&application=${
          archLevel == 'sponsor' ? process.env.REACT_APP_NAME : process.env.REACT_APP_NAME_TEMP
        }&sq_visit_id=${sq_visit_id}&publish_doc_version=${publish_doc_version}&time_zone_id=${time_zone_id}&is_published_etmf=${is_published_etmf}&update=${update}`,
        method: 'POST'
      }),
      extraOptions: { maxRetries: 3 }
    }),
    createNewVersion: builder.mutation<any, any>({
      query: ({ site_id, study_id, country, application, application_section, sq_visit_id }) => ({
        url: `${formatString(
          endPoints.sqFollowupLatter.createNewVersion,
          { key: urlKeys.site_id, value: site_id },
          { key: urlKeys.study_id, value: study_id },
          { key: urlKeys.sq_visit_id, value: sq_visit_id }
        )}?country=${country}&&application=${application}&application_section=${application_section}&application_module_section=STUDY LOGS`,
        method: 'POST'
      })
    })
  })
});

export const {
  useLazyGetSqFollowupLetterQuery,
  useLazyGetSqPublishFollowupLetterQuery,
  useLazySelectSqFollowupLetterQuery,
  useUpdateSqFollowupLetterMutation,
  useSignSqFollowupLetterMutation,
  usePublishSqFollowupLetterMutation,
  useCreateNewVersionMutation
} = sqFollowupLetterApi;
